import React, { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  en: {
    "nav.businesses": "For businesses",
    "nav.individuals": "For individuals",
    "nav.resolutionary": "Become a resolutionary",
    "nav.faqs": "FAQs",
    "nav.login": "Sign in",
    "nav.getStarted": "File a dispute",
    "nav.talkExpert": "Talk to an expert",

    "hero.eyebrow": "Online Dispute Resolution · India",
    "hero.headline": "Resolve with respect.",
    "hero.headlineHi": "सम्मान के साथ समाधान।",
    "hero.sub": "A fair hearing, fully online. eSulah brings businesses and individuals together to resolve disputes in days — not years — without lawyers, courts, or paper.",
    "hero.subHi": "Samadhan, Sammaan ke Saath.",
    "hero.cta": "Talk to an expert",
    "hero.cta.secondary": "File a dispute",

    "section.what": "What we do",
    "mission.title": "Two parties. One platform. A considered way back to balance.",
    "mission.body": "eSulah is an Online Dispute Resolution platform enabling Online Mediation, Online Arbitration and Online Lok Adalat — built on Indian law, run by qualified mediators and arbitrators, designed for everyone.",

    "section.businesses": "For institutions",
    "section.features": "How the platform works",
    "section.enforce": "Legally enforceable",
    "section.trusted": "Recognised across",
    "section.individuals": "For individuals",
    "section.resolutionary": "For lawyers & law students",
    "section.contact": "Get in touch",

    "stats.filed": "Disputes filed",
    "stats.resolved": "Disputes resolved",
    "stats.avg": "Avg. resolution",
    "stats.panel": "Panel of mediators & arbitrators",
    "stats.days": "days",

    "footer.disclaimer": "eSulah is a technology platform facilitating ODR. It is not a law firm.",

    // App
    "app.welcome": "Welcome",
    "app.dashboard": "Dashboard",
    "app.cases": "Cases",
    "app.file": "File a dispute",
    "app.team": "Team",
    "app.bulk": "Bulk import",
    "app.course": "ODR course",
    "app.neutrals": "Mediators / Arbitrators",
    "app.users": "Users",
    "app.leads": "Contact leads",
    "app.logout": "Sign out",

    "kpi.total": "Total cases",
    "kpi.open": "Open",
    "kpi.resolved": "Resolved",
    "kpi.resolvedRate": "Resolved rate",
    "kpi.assigned": "Assigned to me",
    "kpi.handled": "Cases handled",
    "kpi.individuals": "Individuals",
    "kpi.businesses": "Businesses",
    "kpi.panel": "Panel",

    "status.Filed": "Filed",
    "status.UnderReview": "Under review",
    "status.NeutralAssigned": "Mediator/Arbitrator assigned",
    "status.NoticeSent": "Notice sent",
    "status.InMediation": "In mediation",
    "status.HearingScheduled": "Hearing scheduled",
    "status.AwaitingAward": "Awaiting award",
    "status.Resolved": "Resolved",
    "status.Closed": "Closed",

    "btn.fileDispute": "File a dispute",
    "btn.viewAll": "View all",
    "btn.export": "Export",
    "btn.exportCsv": "Export CSV",
    "btn.exportPdf": "Export PDF",
  },
  hi: {
    "nav.businesses": "व्यवसायों के लिए",
    "nav.individuals": "व्यक्तियों के लिए",
    "nav.resolutionary": "रेज़ोल्यूशनरी बनें",
    "nav.faqs": "सामान्य प्रश्न",
    "nav.login": "लॉगिन",
    "nav.getStarted": "विवाद दर्ज करें",
    "nav.talkExpert": "विशेषज्ञ से बात करें",

    "hero.eyebrow": "ऑनलाइन विवाद समाधान · भारत",
    "hero.headline": "सम्मान के साथ समाधान।",
    "hero.headlineHi": "Resolve with respect.",
    "hero.sub": "एक निष्पक्ष सुनवाई, पूरी तरह ऑनलाइन। eSulah व्यवसायों और व्यक्तियों को कुछ दिनों में, बिना अदालत के, विवाद सुलझाने में मदद करता है।",
    "hero.subHi": "सम्मान के साथ समाधान।",
    "hero.cta": "विशेषज्ञ से बात करें",
    "hero.cta.secondary": "विवाद दर्ज करें",

    "section.what": "हम क्या करते हैं",
    "mission.title": "दो पक्ष। एक मंच। संतुलन की ओर एक विचारशील रास्ता।",
    "mission.body": "eSulah एक ODR मंच है — ऑनलाइन मध्यस्थता, ऑनलाइन सालिसी, और ऑनलाइन लोक अदालत। भारतीय कानून पर आधारित, योग्य न्यूट्रल्स द्वारा संचालित।",

    "section.businesses": "संस्थानों के लिए",
    "section.features": "मंच कैसे काम करता है",
    "section.enforce": "कानूनी रूप से लागू",
    "section.trusted": "मान्यता प्राप्त",
    "section.individuals": "व्यक्तियों के लिए",
    "section.resolutionary": "वकीलों और छात्रों के लिए",
    "section.contact": "संपर्क करें",

    "stats.filed": "दर्ज विवाद",
    "stats.resolved": "हल विवाद",
    "stats.avg": "औसत समाधान",
    "stats.panel": "न्यूट्रल पैनल",
    "stats.days": "दिन",

    "footer.disclaimer": "eSulah एक तकनीकी मंच है जो ODR को सक्षम करता है। यह एक लॉ फर्म नहीं है।",

    "app.welcome": "स्वागत है",
    "app.dashboard": "डैशबोर्ड",
    "app.cases": "मामले",
    "app.file": "विवाद दर्ज करें",
    "app.team": "टीम",
    "app.bulk": "बल्क इम्पोर्ट",
    "app.course": "ODR कोर्स",
    "app.neutrals": "न्यूट्रल्स",
    "app.users": "उपयोगकर्ता",
    "app.leads": "संपर्क लीड्स",
    "app.logout": "लॉगआउट",

    "kpi.total": "कुल मामले",
    "kpi.open": "खुले",
    "kpi.resolved": "हल",
    "kpi.resolvedRate": "हल दर",
    "kpi.assigned": "मुझे सौंपे गए",
    "kpi.handled": "संभाले गए",
    "kpi.individuals": "व्यक्ति",
    "kpi.businesses": "व्यवसाय",
    "kpi.panel": "पैनल",

    "status.Filed": "दर्ज",
    "status.UnderReview": "समीक्षाधीन",
    "status.NeutralAssigned": "न्यूट्रल नियुक्त",
    "status.NoticeSent": "नोटिस भेजा",
    "status.InMediation": "मध्यस्थता में",
    "status.HearingScheduled": "सुनवाई निर्धारित",
    "status.AwaitingAward": "निर्णय प्रतीक्षित",
    "status.Resolved": "हल",
    "status.Closed": "बंद",

    "btn.fileDispute": "विवाद दर्ज करें",
    "btn.viewAll": "सभी देखें",
    "btn.export": "एक्सपोर्ट",
    "btn.exportCsv": "CSV एक्सपोर्ट",
    "btn.exportPdf": "PDF एक्सपोर्ट",
  },
};

const I18nCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("esulah-lang") || "en"; } catch { return "en"; }
  });
  useEffect(() => {
    try { localStorage.setItem("esulah-lang", lang); } catch {}
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => (DICT[lang] && DICT[lang][key]) || DICT.en[key] || key;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
